// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:08:08

export default {
  "id": "jelly-belly-make-the-elephant",
  "slug": "jelly-belly-make-the-elephant",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/3916ef22a29e46bd9e187a3185e965cb-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/3916ef22a29e46bd9e187a3185e965cb/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Jelly-Belly. Make the Elephant",
      "description": "It is a puzzle like \"Watermelon game\" where you need drop animals in a container and try not to cross the top line. Animals of the same type will combine and create a larger animal. Merge the animals to create the biggest animal - Elephant.",
      "instructions": "Connect same animals with your finger or mouse to get new ones!\n\nKeyboard arrows to move new animal\nSpacebar or down arrow to drop the animal\n\nGame will over when animal crossed the top line.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "2048",
        "2d"
      ]
    },
    "zh-CN": {
      "title": "果冻肚子。制作大象",
      "description": "这是一款类似“西瓜游戏”的益智游戏，你需要将动物投入容器中，并尽量不越过顶部线。同类型的动物会合并成更大的动物。合并动物，创建最大的动物——大象。",
      "instructions": "用手指或鼠标连接相同的动物，以获得新的动物！\n\n使用键盘方向键移动新动物\n空格键或下箭头键放下动物\n\n当动物越过顶部线时游戏结束。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "2048",
        "二维"
      ]
    },
    "zh-TW": {
      "title": "果冻肚子。變出大象",
      "description": "這是一款類似「西瓜遊戲」的謎題遊戲，你需要將動物丟入容器中，並盡量不要讓它們越過頂線。同種類的動物會合併，形成一個更大的動物。將動物合併，創造出最大的動物——大象。",
      "instructions": "用手指或滑鼠連接同樣的動物，以獲得新的動物！\n\n按鍵盤方向鍵移動新動物\n按空格鍵或向下的箭頭放下動物\n\n當動物穿越頂線時，遊戲結束。",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "2048",
        "二維"
      ]
    },
    "zh-HK": {
      "title": "果冻腹。變成大象",
      "description": "是一款類似「西瓜遊戲」的謎題遊戲，你需要將動物丟入容器中，並試著不要讓它們越過頂線。同種類的動物會合併並創造出更大的動物。將動物合併以創造出最大的動物——大象。",
      "instructions": "用手指或鼠標連接相同動物，即可獲得新的動物！\n\n按鍵盤方向鍵移動新動物\n空格鍵或向下箭頭放下動物\n\n當動物穿越頂線時，遊戲結束。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "2048",
        "二維"
      ]
    },
    "ja": {
      "title": "ジェリー・ベリー。象を作れ",
      "description": "「水蜜桃ゲーム」のようなパズルで、容器に動物を落とし、上のラインを越えないようにすることが求められます。同じ種類の動物が合体し、大きな動物を作り出します。動物を合体させて最大の動物－象を作りましょう。",
      "instructions": "同じ動物を指やマウスで結びつけて新しい動物を獲得しましょう！\n\n新しい動物を移動するには、キーボードの矢印を使用\nスペースバーまたは下矢印で動物を落下\n\n動物が上のラインを越えるとゲームが終了します。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "2048",
        "2D"
      ]
    },
    "ko": {
      "title": "젤리벨리. 엘리픽트 만들기",
      "description": "\"수박게임\"과 같은 패ズل 게임입니다. 컨테이너에 동물을 내려놓고 최상단 라인을 넘지 않도록 해야 합니다. 같은 유형의 동물은 합쳐져 더 큰 동물이 되죠. 동물들을 합쳐 가장 큰 동물 - 코끼리를 만들어 보세요.",
      "instructions": "용지로 동물을 연결하여 새로운 동물을 얻으세요!\n\n키보드 아라벨스로 새로운 동물을 이동\n스페이스바나 아래 방향키로 동물을 내려놓기\n\n동물이 상단 줄을 건너면 게임이 끝납니다.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "2048",
        "2차원"
      ]
    },
    "fr": {
      "title": "Jelly-Belly. Fais l'Éléphant",
      "description": "C'est un puzzle similaire au \"jeu du pastèque\" où il faut faire tomber des animaux dans un contenant tout en essayant de ne pas traverser la ligne supérieure. Les animaux du même type se combinent pour créer un animal plus grand. Fondez les animaux pour créer le plus grand animal - l'éléphant.",
      "instructions": "Connectez les mêmes animaux avec votre doigt ou votre souris pour obtenir de nouveaux animaux !\n\nFlèches du clavier pour déplacer le nouvel animal\nBarre d'espace ou flèche vers le bas pour faire tomber l'animal\n\nLe jeu se termine lorsque l'animal traverse la ligne du haut.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "2048",
        "2D"
      ]
    }
  }
};
